"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _alignments = require("../constants/alignments");

var AlignmentIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "AlignmentButton__AlignmentIcon",
  componentId: "sc-1ryj6jl-0"
})(["padding:9px 10px 0 !important;"]);

var AlignmentButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlignmentButton, _Component);

  function AlignmentButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AlignmentButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AlignmentButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleSelectedChange = function () {
      _this.props.onSelect(_this.props.alignment);
    };

    return _this;
  }

  (0, _createClass2.default)(AlignmentButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selected = _this$props.selected,
          alignment = _this$props.alignment,
          tooltip = _this$props.tooltip;
      return _react.default.createElement(_UISelectableBox.default, {
        selected: selected,
        onSelectedChange: this.handleSelectedChange,
        padded: false
      }, _react.default.createElement(AlignmentIcon, {
        size: "large",
        name: _alignments.AlignmentIconMap[alignment],
        screenReaderText: _I18n.default.text(tooltip)
      }));
    }
  }]);
  return AlignmentButton;
}(_react.Component);

AlignmentButton.propTypes = {
  alignment: _propTypes.default.oneOf(Object.keys(_alignments.Alignments).map(function (key) {
    return _alignments.Alignments[key];
  })).isRequired,
  onSelect: _propTypes.default.func.isRequired,
  selected: _propTypes.default.bool.isRequired,
  tooltip: _propTypes.default.string
};
var _default = AlignmentButton;
exports.default = _default;
module.exports = exports.default;